import React from 'react';
import {
  Backdrop, Button, Card, CardActions, CardContent, CircularProgress, Divider, Modal
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { useState } from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { base64Reader, saveFotograf } from 'src/utils/storage/StrPhoto';


const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function FilePopup({ open, onClose, FisNo, DosyaTipi, DosyaTipiText, uploadingFile, setUploadingFile, className, type = 0 }) {
  const classes = useStyles();
  const [label, setLabel] = useState("Dosya seçiniz...");
  const [loading, setLoading] = useState(false);

  if (!open) {
    return null;
  }

  const handleChangeStatus = () => {

  }

  const handleSubmit = async (files, allFiles) => {
    if (!window.navigator.onLine) { // offline
      setLoading(true);
      files.forEach(f => {

        var reader = new FileReader()
        reader.onload = function (base64) {
          saveFotograf(FisNo, base64.target.result, DosyaTipi, f.meta.name, f.meta.type);
        };
        reader.readAsDataURL(f.file);
      });
      allFiles.forEach(f => f.remove());
      setLabel("Internet bağlantınız olmadığı için dosyalar cihazınıza kaydedildi. Merkeze Gönder aşamasında sisteme otomatik olarak yüklenecektir.");
      setLoading(false);
    } else {
      setLoading(true);
      var tempArray = uploadingFile;
      for (let i = 0; i < files.length; i++) {
        const fileMaterial = files[i].file;
        const metaMaterial = files[i].meta;
        let base64ResultMaterial = '';
        if (metaMaterial.type.indexOf('image') !== -1) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const image = new Image();
          image.src = URL.createObjectURL(fileMaterial);
          await new Promise((resolve, reject) => {
            image.onload = () => {
              const maxWidth = 1920;
              const maxHeight = 1920;
              let width = image.width;
              let height = image.height;
              if (width > maxWidth || height > maxHeight) {
                if (width / height > maxWidth / maxHeight) {
                  width = maxWidth;
                  height = Math.round(maxWidth * (image.height / image.width));
                } else {
                  height = maxHeight;
                  width = Math.round(maxHeight * (image.width / image.height));
                }
              }
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(image, 0, 0, width, height);
              base64ResultMaterial = canvas.toDataURL(metaMaterial.type, 1).split(',')[1];
              resolve();
            };
            image.onerror = reject;
          });
        } else {
          base64ResultMaterial = await base64Reader(fileMaterial);
        }

        const data = {

          Title: DosyaTipiText + ' - ' + metaMaterial.name,
          MIMEType: metaMaterial.type,
          ServiscePaperId: 0,
          DosyaTipi: DosyaTipi.toString(),
          FileData: base64ResultMaterial,
          type: type.toString(),
          FileUploadData:files[i]
        }
        tempArray = [...tempArray, data]
        // uploadFiles(data)
        setLoading(false)
        // setUploadFilePopUp(false)
      }
      setUploadingFile(tempArray);
      allFiles.forEach(f => f.remove())

    }


  }

  



  return (
    <Modal
      onClose={() => { setLabel("Dosya seçiniz..."); onClose() }}
      open={open}
    >
      <Card
        className={clsx(classes.root, className)}
      >
        <form>
          <CardContent color='secondary'>
            {
              loading ?
                <Backdrop className={classes.backdrop} open={loading}>
                  <CircularProgress color="inherit" />
                </Backdrop>
                : <Dropzone
                  onChangeStatus={handleChangeStatus}
                  onSubmit={handleSubmit}
                  styles={{
                    dropzone: { minHeight: 200, maxHeight: 250 },
                  }}
                  inputContent={label}
                  submitButtonContent="Yükle"
                  accept="image/*"
                  maxFiles={5}
                  minSize={0}
                  maxSize={8072000}
                  inputWithFilesContent={uploadingFile => `${5 - uploadingFile.length} ekle`}
                />
            }

          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={() => { setLabel("Dosya seçiniz..."); onClose() }}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FilePopup.defaultProps = {
  open: false,
  onClose: () => { }
};

export default FilePopup;
